import React from 'react';
import styled from '@emotion/styled';

const UnorderedList = styled.ul`
  display: inline-flex;
  flex-direction: row;
  padding: 0;
  margin: 0;
  list-style-type: none;
  white-space: nowrap;
`;

const ListItem = styled.li`
  font-size: 0.75rem;
  font-weight: 600;
`;

const ListLink = styled.a`
  color: #0085c3;
  text-decoration: none;
  margin-left: 1.5rem;

  :hover {
    text-decoration: underline;
  }
`;

const FooterLinks = () => {
  return (
    <UnorderedList>
      <ListItem>
        <ListLink href="https://support.liveoptics.com/" target="_blank" rel="noopener">
          Support
        </ListLink>
      </ListItem>
      <ListItem>
        <ListLink href="/EULA">EULA</ListLink>
      </ListItem>
      <ListItem>
        <ListLink
          href="http://www.dell.com/learn/us/en/uscorp1/policies-privacy"
          target="_blank"
          rel="noopener"
        >
          Privacy
        </ListLink>
      </ListItem>
    </UnorderedList>
  );
};

export default FooterLinks;
